import React from "react";
import MainImage from "../../assets/HeroImages/MainPot4.jpg";
import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import PastWork from "../../components/PastWord";

function SEOPage() {
  return (
    <main className="relative min-h-screen w-screen overflow-x-hidden bg-[#F4F3E1]">
      <title>SEO Services for Women Entrepreneurs | Her Growth Co.</title>
      <meta
        name="description"
        content="Our expert SEO strategies help female-led brands rank higher, drive traffic, and get seen by the right audience."
      />
      <meta
        name="keywords"
        content="SEO for women entrepreneurs, rank higher on Google, expert SEO strategy for coaches, local SEO for consultants, keyword clarity for female founders, visibility for women-owned businesses, SEO solutions for thought leaders"
      />

      <section className="bg-[#F7F3F2]">
        <div
          className="relative h-auto bg-cover bg-center"
          style={{
            clipPath: "polygon(0 0, 100% 0, 100% 80%, 0 100%)",
            backgroundImage: `url(${MainImage})`,
            padding: "20px",
            width: "100%",
          }}
        >
          <Navbar />
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="flex items-center justify-center">
              <h1 className="text-black italic text-3xl font-semibold max-w-96 bg-[#CFF098] ">SEO Services</h1>
            </div>
          </div>
        </div>

        <section className="bg-[#F7F3F2]">
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="flex flex-col items-center text-center">
              <h2 className="text-3xl font-regular md:text-5xl text-black max-w-2xl uppercase">
                SEO That Puts You On the Map
              </h2>
              <p className="mb-8 mt-4 max-w-lg text-base text-black md:mb-12 md:text-lg font-light">
                Whether you need a quick visibility boost or a focused local strategy, we’ve got the tools and expertise to get you noticed.
              </p>
            </div>

            {/* SEO Packages Section */}
            <div className="grid gap-10 sm:grid-cols-1 md:grid-cols-2 md:gap-6">
              {/* Visibility Audit Package */}
              <div className="grid gap-6 border border-solid border-black p-8 md:p-10 bg-white rounded-xl">
                <h3 className="text-xl font-semibold text-black text-center">Visibility Audit</h3>
                <p className="text-black text-lg font-light text-center">
                  Perfect for those unsure why their site isn’t attracting clients.
                </p>
                <ul className="text-black text-base font-light list-disc list-inside mt-4">
                  <li>Website Speed Analysis</li>
                  <li>Mobile Responsiveness Check</li>
                  <li>On-Page SEO Review (titles, meta descriptions, headers)</li>
                  <li>Local SEO Assessment (Google Business Profile check)</li>
                  <li>User Experience Highlights</li>
                  <li>Personalized Loom Walkthrough</li>
                  <li>Concise Written Report</li>
                </ul>
              </div>

              {/* Local SEO Accelerator Package */}
              <div className="grid gap-6 border border-solid border-black p-8 md:p-10 bg-white rounded-xl">
                <h3 className="text-xl font-semibold text-black text-center">Local SEO Accelerator</h3>
                <p className="text-black text-lg font-light text-center">
                  For professionals who rely on local clients and want to rank higher fast.
                </p>
                <ul className="text-black text-base font-light list-disc list-inside mt-4">
                  <li>Google Business Profile Optimization</li>
                  <li>Local Citation Building + NAP Consistency</li>
                  <li>In-depth Local Keyword Research & Implementation</li>
                  <li>Online Review Management Strategy + Templates</li>
                  <li>Local Content Optimization (including landing pages)</li>
                  <li>Monthly Local Ranking & Performance Reports</li>
                  <li>1-on-1 Local SEO Strategy Session</li>
                </ul>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center mt-16">
              <a href="/contact" className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black uppercase">
                START A SEO Project →
              </a>
              <p className="text-black text-lg font-light mt-6 w-[400px] text-center">
                Let’s look under the hood of your SEO — and show you what’s really holding you back.
              </p>
            </div>
            
          </div>
          <PastWork/>
        </section>
        <Footer />
      </section>
    </main>
  );
}

export default SEOPage;
